/**
 * The year-end close plan's route (FSD 2.2.8, 2.2.1 year-end).
 *
 * A per-feature file: the R0 integration packet spreads `CLOSE_YEAR_END_ROUTES`
 * into the router, so this packet edits neither `src/router/index.ts` nor the
 * close module's root `routes.ts`.
 *
 * The permission is the server's own: `GET /reports/year-end-close-plan`
 * declares `gl.report.read` (`internal/glreport/handler.go`). Exporting needs
 * `gl.report.export` as well, and is checked on the button, not the route.
 */

import type { RouteRecordRaw } from 'vue-router'

import { GL_PERMISSIONS } from '@/modules/gl/permissions'

export const CLOSE_YEAR_END_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/year-end-plan',
    name: 'close-year-end-plan',
    component: () => import('@/modules/close/year-end/YearEndClosePlanView.vue'),
    meta: { permission: GL_PERMISSIONS.reportRead, titleKey: 'close.yearEnd.routeTitle' },
  },
]
